import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import DoneEstatusCompra from "assets/img/done_estatus_compra.png";
import IconoPendientePago from "assets/img/pendiente_pago.png";
import IconoCompraCancelada from "assets/img/compra_cancelacion1.png";
import { ArrowBack, Close } from "@material-ui/icons";
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.jsx";
import Globales from "utils/Globales";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import moment from "moment-timezone";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import styled from "styled-components";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Button from "components/CustomButtons/Button.jsx";

const ResponsiveTitleHidden = styled.th`
	border-bottom: 3px solid rgba(128, 128, 128, 0.3);
	text-align: center;

	@media (max-width: 768px) {
		display: none;
	}
`;

const ResponsiveHidden = styled.td`
	text-align: center;

	@media (max-width: 768px) {
		display: none;
	}
`;

const useStyles = makeStyles(modalStyle);

const ModalDetalleVenta = ({
	EsVenta,
	DetallesCompra,
	eventoCerrarDetalles,
	onCancelarPedido,
	CambiarFormatoFecha,
}) => {
	const classes = useStyles();

	const [tallas, setTallas] = useState([]);
	const [domicilio, setDomicilio] = useState("");
	const [numeroSeguimiento, setNumeroSeguimiento] = useState("");
	const [contacto, setContacto] = useState("");
	const [referenciaContacto, setReferenciaContacto] = useState("");
	const [tipoPago, setTipoPago] = useState("");
	const [fechaDeCompra, setFechaDeCompra] = useState("");

	// DATOS PAGO TARJETA
	const [banco, setBanco] = useState("");
	const [red, setRed] = useState("");
	const [tipo, setTipo] = useState("");
	const [ultimos4, setUltimos4] = useState("");
	const [autorizacion, setAutorizacion] = useState("");
	const [total, setTotal] = useState("");

	// DATOS PAGO OXXO
	const [referencia, setReferencia] = useState("");

	// Productos
	const [productos, setProductos] = useState([]);
	const [steps, setSteps] = useState([]);
	const [numeroStep, setNumeroStep] = useState(0);

	// Envio
	const [paqueteria, setPaqueteria] = useState("");
	const [precioEnvio, setPrecioEnvio] = useState("");
	const [numeroGuia, setNumeroGuia] = useState("");
	const [numeroDeRastreo, setNumeroDeRastreo] = useState("");
	const [linkRastreo, setLinkRastreo] = useState("");
	const [esCompraEnviada, setEsCompraEnviada] = useState(false);
	const [pendientePago, setPendientePago] = useState(false);
	const [esCompraCancelada, setEsCompraCancelada] = useState(false);
	const [esCompraCanceladaUsuario, setEsCompraCanceladaUsuario] = useState(
		false
	);
	const [folioPedido, setFolioPedido] = useState("");
	const [fechaCancelacionPago, setFechaCancelacionPago] = useState("");
	
	// Cupon
	const [descuentoCupon, setDescuentoCupon] = useState(0);
	const [codigoCupon, setCodigoCupon] = useState("");

	const cambiarFormatoFecha = (Fecha) => {
		var FechaMoment = moment(Fecha);
		FechaMoment.tz("America/Mazatlan").format("ha z");
		var FechaObj = new Date(FechaMoment._i);
		var Fecha2 = FechaObj.toLocaleDateString("en-GB");
		return Fecha2;
	};

	const obtenerNombreTamaño = (id, allTallas) => {
		var nombre = "";
		allTallas.forEach((m) => {
			if (m._id === id) {
				nombre = m.NombreTalla;
			}
		});
		return nombre;
	};

	useEffect(() => {
		if (!DetallesCompra) return;

		const conekta = DetallesCompra.responseFromConekta || {};
		const DatosPago =
			conekta.charges?._json?.data?.[0] ||
			conekta.charges?.data?.[0] ||
			conekta._json?.charges?.data?.[0] ||
			null;
		const paymentMethod = DatosPago?.payment_method || {};
		const paymentObject =
			paymentMethod.object ||
			(paymentMethod.type === "card" || paymentMethod.type === "card_payment"
				? "card_payment"
				: paymentMethod.type === "cash" || paymentMethod.type === "cash_payment"
				? "cash_payment"
				: paymentMethod.type === "spei" || paymentMethod.type === "bank_transfer"
				? "bank_transfer"
				: paymentMethod.type || "");

		// Configurar datos de pago
		if (paymentObject === "card_payment") {
			setBanco(paymentMethod.issuer || "");
			setRed(
				paymentMethod.brand !== undefined
					? paymentMethod.brand.toUpperCase()
					: ""
			);
			setTipo(
				paymentMethod.type === "debit"
					? "DÉBITO"
					: paymentMethod.type === "credit"
					? "CRÉDITO"
					: paymentMethod.type || ""
			);
			setUltimos4(paymentMethod.last4 || "");
			setAutorizacion(paymentMethod.auth_code || "");
		}

		if (paymentObject === "cash_payment") {
			setReferencia(paymentMethod.reference || "");
		}

		if (paymentObject === "bank_transfer") {
			setReferencia(
				paymentMethod.clabe ||
					paymentMethod.receiving_account_number ||
					paymentMethod.reference ||
					""
			);
		}

		const Domicilio = DetallesCompra.Domicilio;

		// Obtener tallas
		fetch(Globales.Url + "Tallas/ObtenerTallas", {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
				Authorization: Globales.token,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				if (!data.error) {
					setTallas(data.data);

					// Procesar productos
					const productosActualizados = (DetallesCompra.DatosCompra || []).map(
						(item, index) => {
							const producto = DetallesCompra.Productos?.[index] || {};
							const diseno = producto.Diseno || {};
							return {
								...item,
								name: diseno.nombre || producto.NombreProducto || item.name || "",
								talla: obtenerNombreTamaño(producto.Tamano, data.data),
								NombreProducto: producto.NombreProducto || item.nombre_producto || item.name || "",
								ImporteComision: producto.ImporteComision,
							};
						}
					);

					setProductos(productosActualizados);
					setNumeroSeguimiento(DetallesCompra.NumeroDeGuia);
				}
			});

		// Configurar steps del stepper
		let stepsArray = [];
		if (
			DetallesCompra.listaEstatusPedido &&
			DetallesCompra.listaEstatusPedido.length > 0
		) {
			stepsArray = DetallesCompra.listaEstatusPedido.map((estatus) => ({
				nombre: estatus.NombreEstatus,
				numero: estatus.NumeroConsecutivo,
				icono: "",
				imagen: estatus.Icono,
			}));
			stepsArray.sort((a, b) => a.numero - b.numero);
		}

		const estatusPedido = DetallesCompra.EstatusPedido;
		const folioPed = DetallesCompra.FolioPedido;
		const fechaCancelPago =
			DetallesCompra.FechaExpiracionPago == null ||
			DetallesCompra.FechaExpiracionPago == undefined
				? ""
				: DetallesCompra.FechaExpiracionPago;
		const concluidoSistema = DetallesCompra.ConcluidoSistema;
		const numRastreoSkyDropbx =
			DetallesCompra.responseFromSkyDropx?.data?.attributes?.tracking_number ||
			"";
		const isCompraEnviada =
			concluidoSistema === false && numRastreoSkyDropbx === "" ? false : true;
		const isPendientePago =
			estatusPedido === 0 || estatusPedido === "" || estatusPedido === undefined
				? true
				: false;
		const esCompraCanceladaVal =
			DetallesCompra.Estatus === 2 && isPendientePago === true ? true : false;
		const esCompraCanceladaUsr = DetallesCompra.Estatus === 0 ? true : false;

		setEsCompraCanceladaUsuario(esCompraCanceladaUsr);
		setEsCompraEnviada(isCompraEnviada);
		setPendientePago(isPendientePago);
		setFolioPedido(folioPed);
		setEsCompraCancelada(esCompraCanceladaVal);
		setFechaCancelacionPago(fechaCancelPago);

		const indexNumero = stepsArray.findIndex(
			(item) => item.numero === estatusPedido
		);

		// Agregar iconos a los steps
		const stepsConIconos = stepsArray.map((element) => {
			const isActive = element.numero === estatusPedido;

			const baseStyle = {
				height: "48px",
				width: "48px",
				marginTop: "-10px",
				borderRadius: "50%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
				zIndex: isActive ? 10000 : 1000,
				backgroundColor: isActive ? "#FFCC66" : "transparent",
			};

			return {
				...element,
				icono: (
					<div style={baseStyle}>
						<Tooltip title={element.nombre}>
							<img
								src={element.imagen}
								alt={element.nombre}
								style={{ width: "24px", height: "24px" }}
							/>
						</Tooltip>
					</div>
				),
			};
		});

		setSteps(stepsConIconos);
		setNumeroStep(indexNumero);

		const DomicilioSafe = Domicilio || {};
		setDomicilio(
			[
				DomicilioSafe.Calle,
				DomicilioSafe.Colonia,
				DomicilioSafe.Municipio,
				DomicilioSafe.Estado,
				DomicilioSafe.CodigoPostal ? `CP:${DomicilioSafe.CodigoPostal}` : "",
			]
				.filter(Boolean)
				.join(", ")
		);
		setContacto(
			[DomicilioSafe.Nombre, DomicilioSafe.TelefonoReferencia]
				.filter(Boolean)
				.join(", ")
		);
		setReferenciaContacto(
			DomicilioSafe.Referencia === undefined || DomicilioSafe.Referencia === null
				? ""
				: DomicilioSafe.Referencia
		);
		setTipoPago(paymentObject);
		setFechaDeCompra(DetallesCompra.FechaDeCompra);
		const amountCentavos = DatosPago?.amount || conekta._json?.amount || 0;
		setTotal(convertirPesos(amountCentavos / 100, 10));

		// Configurar cupón
		// El descuento puede venir en metadata (en pesos) o en discount_lines (en centavos)
		let cuponDiscountAmount = 0;
		let cuponCodigo = "";
		
		if (DetallesCompra.responseFromConekta?._json?.metadata?.CuponDiscountAmount) {
			cuponDiscountAmount = parseFloat(DetallesCompra.responseFromConekta._json.metadata.CuponDiscountAmount);
			cuponCodigo = DetallesCompra.responseFromConekta._json.metadata.CuponCodigo || "";
		} else if (DetallesCompra.responseFromConekta?._json?.discount_lines?.data?.[0]?.amount) {
			// Si viene en discount_lines, está en centavos
			cuponDiscountAmount = parseFloat(DetallesCompra.responseFromConekta._json.discount_lines.data[0].amount) / 100;
			cuponCodigo = DetallesCompra.responseFromConekta._json.discount_lines.data[0].code || "";
		}
		
		setDescuentoCupon(cuponDiscountAmount);
		setCodigoCupon(cuponCodigo);

		// Configurar envío
		const datosPaqueteria = DetallesCompra.DatosPaqueteria;
		// Intentar obtener el nombre de la paquetería de múltiples fuentes
		const paqueteriaNombre = datosPaqueteria?.Paqueteria 
			|| datosPaqueteria?.provider_display_name
			|| datosPaqueteria?.data?.Paqueteria
			|| DetallesCompra.responseFromConekta?.shipping_lines?._json?.data?.[0]?.carrier
			|| DetallesCompra.responseFromConekta?._json?.shipping_lines?.data?.[0]?.carrier
			|| "";
		setPaqueteria(paqueteriaNombre);
		setPrecioEnvio(
			DetallesCompra.responseFromConekta?.shipping_lines?._json?.data?.[0]?.amount
			|| DetallesCompra.responseFromConekta?._json?.shipping_lines?.data?.[0]?.amount
			|| ""
		);
		setNumeroGuia(DetallesCompra.NumeroDeGuia || "");
		// Intentar obtener el número de rastreo de múltiples fuentes
		const trackingNumber = DetallesCompra.NumeroDeRastreo 
			|| DetallesCompra.responseFromSkyDropx?.data?.attributes?.tracking_number
			|| "";
		setNumeroDeRastreo(trackingNumber);
		setLinkRastreo(
			DetallesCompra.responseFromSkyDropx === undefined
				? ""
				: DetallesCompra.responseFromSkyDropx.data !== undefined
				? DetallesCompra.responseFromSkyDropx.data.attributes
						.tracking_url_provider
				: ""
		);
	}, [EsVenta, DetallesCompra]);

	const convertirPesos = (pesos) => {
		if (!pesos.toString().includes(".")) {
			return Intl.NumberFormat("es-MX", {
				style: "currency",
				currency: "MXN",
			}).format(pesos / 100);
		}
		return Intl.NumberFormat("es-MX", {
			style: "currency",
			currency: "MXN",
		}).format(pesos || 0);
	};

	const formatearPesos = (pesos) => {
		// Formatea valores que ya están en pesos (no en centavos)
		return Intl.NumberFormat("es-MX", {
			style: "currency",
			currency: "MXN",
		}).format(pesos || 0);
	};
	return (
		<div>
			<GridContainer justify="center" style={{ marginBottom: "3em" }}>
				<GridItem
					lg={12}
					md={12}
					sm={12}
					xs={12}
					style={{ paddingLeft: "15px", paddingRight: "15px" }}
				>
					<span
						onClick={() => eventoCerrarDetalles(false)}
						style={{
							textDecoration: "underline",
							cursor: "pointer",
							fontSize: "1.5em",
							display: "inline-flex",
							alignItems: "center",
							verticalAlign: "middle",
						}}
					>
						<ArrowBack
							style={{ marginRight: "8px", verticalAlign: "middle" }}
						/>{" "}
						Regresar a compras
					</span>
				</GridItem>
			</GridContainer>

			{EsVenta === false ? (
				<GridContainer justify="center">
					<GridItem lg={4} md={3} sm={12} xs={12}>
						<Card>
							<CardHeader color="primary">Envío</CardHeader>
							<CardBody>
								<GridItem>
									<span>
										{paqueteria} {convertirPesos(precioEnvio)}{" "}
									</span>
								</GridItem>

								<GridItem>
									<span>
										N° seguimiento:{" "}
										<a style={{ textDecoration: "underline" }}>
											{" "}
											{numeroSeguimiento === ""
												? "No disponible"
												: numeroSeguimiento}{" "}
										</a>{" "}
									</span>
								</GridItem>

								<GridItem />
							</CardBody>
						</Card>
					</GridItem>
					<GridItem lg={6} md={6} sm={12} xs={12}>
						<Card>
							<CardHeader color="primary">Pago</CardHeader>
							<CardBody>
								{tipoPago === "card_payment" ? (
									<GridItem>
										{red} {tipo} {banco} terminada en {ultimos4}
										<br />
										Pago {total}
										<br />
										Pago #{autorizacion} acreditado{" "}
										{cambiarFormatoFecha(fechaDeCompra)}
									</GridItem>
								) : tipoPago === "bank_transfer" ? (
									<GridItem>
										SPEI / Transferencia
										{referencia ? `: ${referencia}` : ""}
										<br />
										Pago: {total}
										<br />
										{cambiarFormatoFecha(fechaDeCompra)}
									</GridItem>
								) : (
									<GridItem>
										Referencia OXXO: {referencia} <br />
										Pago: {total}
										<br />
										Acreditado: {cambiarFormatoFecha(fechaDeCompra)}
									</GridItem>
								)}
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			) : null}
			<GridContainer justify="center" spacing={2}>
				<GridItem lg={12} md={12} sm={12} xs={12}>
					<Card style={{ width: "100%" }}>
						<CardHeader color="primary" style={{ fontSize: "15px" }}>
							ESTATUS DE PEDIDO: {folioPedido}
						</CardHeader>
						{esCompraCanceladaUsuario ? (
							<CardBody
								style={{
									textAlign: "center",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<div style={{ display: "flex", alignItems: "center" }}>
									<img
										src={IconoCompraCancelada}
										alt="Compra cancelada"
										style={{
											width: "32px",
											height: "32px",
											marginRight: "10px",
										}}
									/>
									<div style={{ fontWeight: "bold" }}>
										SU PEDIDO HA SIDO CANCELADO
									</div>
								</div>
							</CardBody>
						) : esCompraCancelada ? (
							<CardBody
								style={{
									textAlign: "center",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<div style={{ display: "flex", alignItems: "center" }}>
									<img
										src={IconoCompraCancelada}
										alt="Compra cancelada"
										style={{
											width: "32px",
											height: "32px",
											marginRight: "10px",
										}}
									/>
									<div style={{ fontWeight: "bold" }}>
										SU PEDIDO HA SIDO CANCELADO POR FALTA DE PAGO
									</div>
								</div>
							</CardBody>
						) : pendientePago ? (
							<CardBody
								style={{
									textAlign: "center",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<div
									style={{
										display: "flex",
										alignItems: "center",
										flexDirection: "column",
									}}
								>
									<div style={{ display: "flex", alignItems: "center" }}>
										<img
											src={IconoPendientePago}
											alt="Pendiente pago"
											style={{
												width: "32px",
												height: "32px",
												marginRight: "10px",
											}}
										/>
										<div style={{ fontWeight: "bold" }}>PENDIENTE DE PAGO</div>
									</div>
									{fechaCancelacionPago && (
										<p style={{ textAlign: "center" }}>
											Efectúa el pago antes del{" "}
											{new Date(fechaCancelacionPago).toLocaleDateString(
												"es-ES",
												{ weekday: "long", month: "long", day: "numeric" }
											) +
												" a las " +
												new Date(fechaCancelacionPago).toLocaleTimeString(
													"es-ES",
													{ hour: "numeric", minute: "numeric", hour12: true }
												)}
										</p>
									)}
								</div>
							</CardBody>
						) : esCompraEnviada ? (
							<CardBody
								style={{
									textAlign: "center",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
								}}
							>
								<div style={{ display: "flex", alignItems: "center" }}>
									<img
										src={DoneEstatusCompra}
										alt="Done estatus"
										style={{
											width: "32px",
											height: "32px",
											marginRight: "10px",
										}}
									/>
									<div style={{ fontWeight: "bold" }}>
										SU PEDIDO HA SIDO ENVIADO
									</div>
								</div>
							</CardBody>
						) : (
							<CardBody
								style={{
									overflowX: "auto",
									height: "150px",
									marginTop: "10px",
								}}
							>
								<Stepper activeStep={numeroStep} alternativeLabel>
									{steps.map((label, index) => (
										<Step key={index} style={{ height: "48px", width: "48px" }}>
											<StepLabel icon={label.icono} />
										</Step>
									))}
								</Stepper>
							</CardBody>
						)}
					</Card>
				</GridItem>
			</GridContainer>
			{EsVenta ? null : (
				<GridContainer hidden={EsVenta} justify="center" spacing={2}>
					<GridItem lg={12} md={12} sm={12} xs={12}>
						<Card>
							<CardHeader color="primary" style={{ fontSize: "15px" }}>
								INFORMACIÓN DE ENVÍO
							</CardHeader>
							<CardBody style={{ padding: "10px" }}>
								<GridContainer style={{ padding: "10px" }}>
									<GridItem>
										<GridContainer>
											<GridItem
												lg={3}
												md={3}
												sm={12}
												xs={12}
												style={{ marginRight: "-15px" }}
											>
												<span>
													<b>Dirección de entrega:</b>&nbsp;
												</span>
											</GridItem>
											<GridItem lg={8} md={8} sm={12} xs={12}>
												<div style={{ marginRight: "50px" }}>
													<p style={{ marginBottom: "15px" }}>{domicilio},</p>
													<p style={{ marginBottom: "15px" }}>
														Referencia:&nbsp; {referenciaContacto}
													</p>
													<p style={{ marginBottom: "15px" }}>
														Recibe: &nbsp;{contacto}
													</p>
												</div>
											</GridItem>
										</GridContainer>
									</GridItem>
									<GridItem style={{ marginBottom: "15px" }}>
										<GridContainer>
											<GridItem
												lg={3}
												md={3}
												sm={12}
												xs={12}
												style={{ marginRight: "-15px" }}
											>
												<span>
													<b>Paquetería:</b>
												</span>
											</GridItem>
											<GridItem lg={8} md={8} sm={12} xs={12}>
												<span>{paqueteria || "No disponible"}</span>
											</GridItem>
										</GridContainer>
									</GridItem>
									<GridItem>
										<GridContainer>
											<GridItem
												lg={3}
												md={3}
												sm={12}
												xs={12}
												style={{ marginRight: "-15px" }}
											>
												<span>
													<b>Número de Rastreo:</b>
												</span>
											</GridItem>
											<GridItem lg={8} md={8} sm={12} xs={12}>
												{numeroDeRastreo ? (
													linkRastreo ? (
														<a
															href={linkRastreo}
															target="_blank"
															rel="noopener noreferrer"
															style={{ textDecoration: "underline" }}
														>
															{numeroDeRastreo}
														</a>
													) : (
														<span>{numeroDeRastreo}</span>
													)
												) : (
													<span>No disponible</span>
												)}
											</GridItem>
										</GridContainer>
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			)}
			<GridContainer justify="center">
				<GridItem
					lg={12}
					md={12}
					sm={12}
					xs={12}
					style={{ paddingRight: "3px", paddingLeft: "3px" }}
				>
					<Card>
						<CardHeader color="primary" style={{ fontSize: "15px" }}>
							PRODUCTOS
						</CardHeader>
						<CardBody style={{ marginTop: "-10px" }}>
							<table style={{ width: "100%", borderCollapse: "collapse" }}>
								<thead>
									<tr>
										<th
											style={{
												borderBottom: "3px solid rgba(128, 128, 128, 0.3)",
											}}
										>
											<b>Producto</b>
										</th>
										<ResponsiveTitleHidden>
											<b>Talla</b>
										</ResponsiveTitleHidden>
										<ResponsiveTitleHidden>
											<b>Cantidad</b>
										</ResponsiveTitleHidden>
										<th
											style={{
												borderBottom: "3px solid rgba(128, 128, 128, 0.3)",
												textAlign: "right",
											}}
										>
											<b>Precio</b>
										</th>
										<th
											style={{
												borderBottom: "3px solid rgba(128, 128, 128, 0.3)",
												textAlign: "right",
											}}
										>
											<b>Total</b>
										</th>
										{EsVenta && (
											<th
												style={{
													borderBottom: "3px solid rgba(128, 128, 128, 0.3)",
													textAlign: "right",
												}}
											>
												<b>Comisión</b>
											</th>
										)}
									</tr>
								</thead>
								<tbody>
									{productos.map((producto, index) => (
										<tr key={index} style={{ height: "50px" }}>
											<td>
												<div>
													<div style={{ marginBottom: "5px" }}>
														<span style={{ fontSize: "15px" }}>
															<b>{producto.name.toUpperCase()}</b>
														</span>
													</div>
													<div>
														<span style={{ fontSize: "12px", color: "gray" }}>
															{producto.NombreProducto.toUpperCase()}
														</span>
													</div>
												</div>
											</td>
											<ResponsiveHidden>
												<span style={{ fontSize: "15px" }}>
													{producto.talla}
												</span>
											</ResponsiveHidden>
											<ResponsiveHidden>
												<span style={{ fontSize: "15px" }}>
													{producto.quantity}
												</span>
											</ResponsiveHidden>
											<td style={{ textAlign: "right" }}>
												<span>{convertirPesos(producto.unit_price)}</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span>
													{convertirPesos(
														producto.unit_price * producto.quantity
													)}
												</span>
											</td>

											{EsVenta && (
												<td style={{ textAlign: "right" }}>
													<span>
														{convertirPesos(
															producto.ImporteComision * producto.quantity
														)}
													</span>
												</td>
											)}
										</tr>
									))}
									{(() => {
										const subtotalProductos = productos.reduce(
											(acc, curr) => acc + curr.unit_price * curr.quantity,
											0
										) / 100;
										const descuento = descuentoCupon || 0;
										const precioEnvioPesos = precioEnvio ? precioEnvio / 100 : 0;
										const subtotalConDescuento = subtotalProductos - descuento;
										const totalProductos = subtotalConDescuento + precioEnvioPesos;
										
										return (
											<>
												<tr
													style={{
														borderTop: "3px solid rgba(128, 128, 128, 0.3)",
														marginTop: "10px",
													}}
												>
													<th colSpan={EsVenta ? 3 : 2} />
													<ResponsiveHidden style={{ textAlign: "center" }}>
														<div style={{ marginTop: "5px" }}>
															<b style={{ marginTop: "10px" }}>
																{productos.reduce(
																	(acc, curr) => acc + curr.quantity,
																	0
																)}
															</b>
														</div>
													</ResponsiveHidden>
													<ResponsiveHidden />
													<td colSpan={2} style={{ textAlign: "right" }}>
														<div style={{ marginTop: "5px" }}>
															<span style={{ fontSize: "12px", color: "gray", display: "block" }}>
																Subtotal productos:
															</span>
															<b style={{ marginTop: "10px" }}>
																{formatearPesos(subtotalProductos)}
															</b>
														</div>
													</td>
													{EsVenta && (
														<td style={{ textAlign: "right" }}>
															<div style={{ marginTop: "5px" }}>
																<b style={{ marginTop: "10px" }}>
																	{formatearPesos(
																		productos.reduce(
																			(acc, curr) =>
																				acc +
																					parseFloat(
																						curr.ImporteComision * curr.quantity
																					) || 0,
																			0
																		) / 100
																	)}
																</b>
															</div>
														</td>
													)}
												</tr>
												{descuento > 0 && (
													<tr>
														<td colSpan={EsVenta ? 5 : 4} style={{ textAlign: "right", paddingTop: "10px" }}>
															<div style={{ color: "#d32f2f" }}>
																<span style={{ marginRight: "10px" }}>
																	Descuento {codigoCupon ? `(${codigoCupon})` : ""}:
																</span>
																<b>-{formatearPesos(descuento)}</b>
															</div>
														</td>
													</tr>
												)}
												{precioEnvioPesos > 0 && (
													<tr>
														<td colSpan={EsVenta ? 5 : 4} style={{ textAlign: "right", paddingTop: "10px" }}>
															<div>
																<span style={{ marginRight: "10px" }}>
																	Envío:
																</span>
																<b>{formatearPesos(precioEnvioPesos)}</b>
															</div>
														</td>
													</tr>
												)}
												<tr>
													<td colSpan={EsVenta ? 5 : 4} style={{ textAlign: "right", paddingTop: "10px" }}>
														<div>
															<span style={{ marginRight: "10px", fontSize: "16px" }}>
																<b>Total:</b>
															</span>
															<b style={{ fontSize: "16px" }}>
																{formatearPesos(totalProductos)}
															</b>
														</div>
													</td>
												</tr>
											</>
										);
									})()}
								</tbody>
							</table>
						</CardBody>
					</Card>
				</GridItem>
			</GridContainer>
			{DetallesCompra.Estatus == 1 &&
			DetallesCompra.EstatusPedido == 0 &&
			onCancelarPedido &&
			CambiarFormatoFecha ? (
				<GridContainer justify="center">
					<GridItem lg={12} md={12} sm={12} xs={12}>
						<div
							style={{
								textAlign: "center",
								marginTop: "20px",
								marginBottom: "20px",
							}}
						>
							<Button
								color="danger"
								onClick={() =>
									onCancelarPedido(
										DetallesCompra.FechaProximoEstatus,
										DetallesCompra.FechaDeCompra,
										DetallesCompra._id
									)
								}
								size="md"
							>
								Cancelar compra
							</Button>
							<div
								style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}
							>
								{"Cancela antes de: " +
									CambiarFormatoFecha(DetallesCompra.FechaProximoEstatus) +
									" " +
									new Date(
										DetallesCompra.FechaProximoEstatus
									).toLocaleTimeString("en-GB", {
										hour: "numeric",
										minute: "numeric",
										hour12: "false",
									})}
							</div>
						</div>
					</GridItem>
				</GridContainer>
			) : null}
		</div>
	);
};

export default ModalDetalleVenta;
